export const INFERENCE_BLOCKED_REASON_CODES = Object.freeze([
  'no_chain_found',
  'cycle_detected',
  'depth_bound_exceeded',
  'missing_commitment_linkage',
  'missing_plan_baseline',
  'missing_counterfactual_basis',
  'rule_not_certified',
  'rule_not_bound',
  'rule_digest_mismatch',
  'overlap_key_not_approved',
  'never_blend_violation',
  'stale_structure',
  'stale_evidence',
  'scope_mismatch',
  'missing_citation',
  'formula_reconciliation_failure',
] as const);

export type InferenceBlockedReasonCode =
  (typeof INFERENCE_BLOCKED_REASON_CODES)[number];
